import * as yup from 'yup';
import { sharedInterlifeFields } from '@/views/checkouts/companies/Interlife/shared/sharedInterlifeSchema';

export const CarInterlifeSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    return yup.object({
        ...sharedInterlifeFields(
            firstDriverAdditionalPremiumAge,
            secondDriverAdditionalPremiumAge,
            firstDriverAdditionalPremiumLicenseYears,
            secondDriverAdditionalPremiumLicenseYears,
            legalEntity,
            secondDriver,
            discountEntity,
            vehicleType
        ),
    });
};

export default CarInterlifeSchemaBuilder;
